import MultiSelect from '@jimmyboys/liita-ui/dist/components/MultiSelect'
import React from 'react'
import { useController } from 'react-hook-form'

const HFMultiSelect = (props) => {
	const { name, ...attributes } = props
	const {
		field: { ref, onChange, value, ...field },
	} = useController({ name })

	const values = Array.isArray(value)
		? value
				.map((itemValue) => {
					const option = attributes.options?.find(
						(option) => option.value === itemValue
					)
					return { ...option, $isSelected: true }
				})
				.filter((item) => item.value)
		: []

	return (
		<MultiSelect
			{...attributes}
			{...field}
			values={values}
			onChange={(e) => {
				const selection = e.target.value
					.filter(({ $isSelected }) => $isSelected)
					.map(({ value }) => value)
				onChange(selection)
			}}
		/>
	)
}

export default HFMultiSelect
